import { useAuth0 } from '@auth0/auth0-react'
import { useQuery } from '@tanstack/react-query'
import { useEffect, useRef, useState } from 'react'

export type ResponseError = {
  message: string
}

const useApi = <TQueryVars, TQueryResult>(
  queryKey: string[],
  queryFunction: (
    accessToken: string | undefined,
    userId: string | undefined,
    variables?: TQueryVars,
  ) => Promise<TQueryResult>,
  variables?: TQueryVars,
  enabled?: boolean,
) => {
  const [accessToken, setAccessToken] = useState<string>()
  const loading = useRef(false)
  const { user, isAuthenticated, getAccessTokenSilently } = useAuth0()

  useEffect(() => {
    const getToken = async () => {
      if (loading.current) return
      loading.current = true

      try {
        const accessToken = await getAccessTokenSilently()
        setAccessToken(accessToken)
      } catch (error) {
        if (!(typeof error === 'string' && !error.includes('Missing Refresh Token'))) {
          console.warn('[useApi]', error)
        }
        setAccessToken(undefined)
      }
      loading.current = false
    }

    if (isAuthenticated && enabled !== false) {
      getToken()
    }
  }, [getAccessTokenSilently, isAuthenticated, enabled])

  return useQuery({
    queryKey: [...queryKey, accessToken],
    queryFn: () => queryFunction(accessToken, user?.sub, variables),
    enabled: !!accessToken && enabled !== false,
    retry: 1,
  })
}

export default useApi
